export const COMPANY_FETCHING = 'COMPANY_FETCHING'
export const COMPANY_FETCH_SUCCESS = 'COMPANY_FETCH_SUCCESS'
export const COMPANY_FETCH_FAILURE = 'COMPANY_FETCH_FAILURE'
